"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.init = init;
var _react = _interopRequireDefault(require("react"));
var _moment = _interopRequireDefault(require("moment"));
var _ui = require("@unite-us/ui");
function init(Survey, isCreator) {
  var widget = {
    name: 'calendar',
    title: 'Calendar',
    isFit: function isFit(question) {
      return question.getType() === 'text' && question.inputType === 'date';
    },
    isDefaultRender: isCreator,
    iconName: 'icon-datepicker',
    defaultJSON: {
      type: "text",
      inputType: "date"
    },
    widgetIsLoaded: function widgetIsLoaded() {
      return true;
    },
    activatedByChanged: function activatedByChanged() {
      Survey.JsonObject.metaData.addClass('calendar', [], null, 'text');
    },
    render: function render(question) {
      return /*#__PURE__*/_react.default.createElement(_ui.DateField, {
        disabled: question.readOnly,
        dateFormat: "MM/DD/YYYY",
        isUtc: false,
        value: question.value ? (0, _moment.default)(question.value, 'YYYY-MM-DD') : null,
        onChange: function onChange(date) {
          if (date) question.setValueCore(_moment.default.unix(date).format('YYYY-MM-DD'));
        }
      });
    }
  };
  Survey.CustomWidgetCollection.Instance.addCustomWidget(widget, 'customtype');
}
//# sourceMappingURL=CalendarWidget.js.map